export default [// 商城首页
{
  path: '/',
  name: 'shopping',
  meta: {
    noAuth: true,
    title: '商城'
  },
  component: function component() {
    return import('@/pages/shopMall/shopping/shopping');
  }
}, // 店铺首页
{
  path: '/shopHome',
  name: 'shopHome',
  meta: {
    noAuth: true,
    title: '店铺首页'
  },
  component: function component() {
    return import('@/pages/shopMall/shopHome/shopHome');
  }
}, // 店铺聚合页
{
  path: '/shopAggregation',
  name: 'shopAggregation',
  meta: {
    noAuth: true,
    title: '店铺聚合页'
  },
  component: function component() {
    return import('@/pages/shopMall/shopAggregation/shopAggregation');
  }
}, // 品牌馆聚合页
{
  path: '/brandHall',
  name: 'brandHall',
  meta: {
    noAuth: true,
    title: '品牌馆'
  },
  component: function component() {
    return import('@/pages/shopMall/brandHall/brandHall');
  }
}, // 在线询盘
{
  path: '/onlineEnquiry',
  name: 'onlineEnquiry',
  meta: {
    noAuth: true,
    title: '在线询盘'
  },
  component: function component() {
    return import('@/pages/shopMall/onlineEnquiry/onlineEnquiry');
  }
}, // 在线询盘-询盘记录
{
  path: '/enquiryRecord',
  name: 'enquiryRecord',
  meta: {
    noAuth: true,
    title: '询盘记录'
  },
  component: function component() {
    return import('@/pages/shopMall/onlineEnquiry/enquiryRecord/enquiryRecord');
  }
}, // 在线询盘-询盘详情
{
  path: '/enquiryDetail',
  name: 'homeEnquiryDetail',
  meta: {
    noAuth: true,
    title: '询盘详情'
  },
  component: function component() {
    return import('@/pages/shopMall/onlineEnquiry/enquiryDetail/enquiryDetail');
  }
}, // 商品列表
{
  path: '/list',
  name: 'list',
  meta: {
    noAuth: true,
    title: '商城列表'
  },
  component: function component() {
    return import('@/pages/shopMall/list/list');
  }
}, // 电子超市商品-详情
{
  path: '/ecDetail/:skuId/:supplierShopId/:supplierId',
  name: 'ecDetail',
  component: function component() {
    return import('@/pages/shopMall/detail/ecDetail');
  }
}, //   协议商品-详情
{
  path: '/agrDetail/:skuId/:supplierShopId/:supplierId',
  name: 'agrDetail',
  component: function component() {
    return import('@/pages/shopMall/detail/agrDetail');
  }
}, //   无协议商品-详情
{
  path: '/unagrdetail/:skuId/:supplierShopId/:supplierId',
  name: 'unagrdetail',
  component: function component() {
    return import('@/pages/shopMall/detail/unagrdetail');
  }
}, // 登录
{
  path: '/login',
  name: 'login',
  meta: {
    title: '$t:page.login.title'
  },
  component: function component() {
    return import('@/pages/shopMall/login/login');
  }
}, // 注册
{
  path: '/register',
  name: 'register',
  meta: {
    title: '$t:page.register.title'
  },
  component: function component() {
    return import('@/pages/shopMall/register/register');
  }
}, // 完善信息
{
  path: '/preInfo',
  name: 'preInfo',
  meta: {
    title: '$t:page.preInfo.title'
  },
  component: function component() {
    return import('@/pages/shopMall/preInfo/preInfo');
  }
}, // 购物车
{
  path: '/cart',
  name: 'cart',
  meta: {
    title: '$t:page.cart.title'
  },
  component: function component() {
    return import('@/pages/shopMall/cart/cart');
  }
}, {
  // 商家平台
  path: '/merchantPlatform',
  name: 'merchantPlatform',
  component: function component() {
    return import('@/pages/shopMall/merchantPlatform/merchantPlatform');
  }
}, {
  // 商家平台 - 合作登记
  path: '/infoReg',
  name: 'infoReg',
  component: function component() {
    return import('@/pages/shopMall/merchantPlatform/infoReg');
  }
}, {
  // 商家平台 - 查看政策
  path: '/merchantPolicy',
  name: 'merchantPolicy',
  component: function component() {
    return import('@/pages/shopMall/merchantPlatform/merchantPolicy');
  }
}, // 企业下单
{
  path: '/extPlaceAnOrder',
  name: 'extPlaceAnOrder',
  component: function component() {
    return import('@/pages/shopMall/cart/extPlaceAnOrder');
  }
}, // 企业下单
{
  path: '/placeAnOrder',
  name: 'placeAnOrder',
  component: function component() {
    return import('@/pages/shopMall/cart/placeAnOrder');
  }
}, // 企业下单
{
  path: '/placeAnOrderResults',
  name: 'placeAnOrderResults',
  component: function component() {
    return import('@/pages/shopMall/cart/placeAnOrderResults');
  }
}, // 购物车订单支付
{
  path: '/cartPayment',
  name: 'cartPayment',
  component: function component() {
    return import('@/pages/shopMall/cart/cartPayment');
  }
}, // 公告列表
{
  path: '/noticeList',
  name: 'noticeList',
  meta: {
    title: '$t:page.noticeList.title'
  },
  component: function component() {
    return import('@/pages/shopMall/noticeList/noticeList');
  }
}, // 公告详情
{
  path: '/noticeDetail',
  name: 'noticeDetail',
  meta: {
    title: '$t:page.noticeList.title'
  },
  component: function component() {
    return import('@/pages/shopMall/noticeList/noticeDetail');
  }
}, // 公告列表
{
  path: '/newsList',
  name: 'newsList',
  meta: {
    title: '$t:page.newsList.title'
  },
  component: function component() {
    return import('@/pages/shopMall/newsList/newsList');
  }
}, // 公告详情
{
  path: '/newsDetail',
  name: 'newsDetail',
  meta: {
    title: '$t:page.newsList.title'
  },
  component: function component() {
    return import('@/pages/shopMall/newsList/newsDetail');
  }
}, // 消息列表
{
  path: '/messageList',
  name: 'messageList',
  meta: {
    title: '$t:page.messageList.title'
  },
  component: function component() {
    return import('@/pages/shopMall/messageList/messageList');
  }
}, // 消息详情
{
  path: '/messageDetail',
  name: 'messageDetail',
  meta: {
    title: '$t:page.messageList.title'
  },
  component: function component() {
    return import('@/pages/shopMall/messageList/messageDetail');
  }
}, // 帮助中心
{
  path: '/helpCenter',
  name: 'helpCenter',
  meta: {
    title: '帮助中心'
  },
  component: function component() {
    return import('@/pages/shopMall/helpCenter/helpCenter');
  }
}, {
  // 比选页面
  path: '/comparison',
  name: 'comparison',
  component: function component() {
    return import('@/pages/shopMall/comparison/comparison');
  }
}, {
  path: '/comparisonUpFile',
  name: 'comparisonUpFile',
  component: function component() {
    return import('@/pages/shopMall/comparison/comparisonUpFile');
  }
}, {
  path: '/comparisonResult',
  name: 'comparisonResult',
  component: function component() {
    return import('@/pages/shopMall/comparison/comparisonResult');
  }
}, {
  path: '/supplierInfo',
  name: 'supplierInfo',
  component: function component() {
    return import('@/pages/shopMall/comparison/supplierInfo');
  }
}, {
  path: '/comparisonDetail',
  name: 'comparisonDetail',
  component: function component() {
    return import('@/pages/shopMall/comparison/comparisonDetail');
  }
}, {
  path: '/comparisonDetailBatch',
  name: 'comparisonDetailBatch',
  component: function component() {
    return import('@/pages/shopMall/comparison/comparisonDetailBatch');
  }
}, {
  // 忘记密码
  path: '/authentication',
  name: 'authentication',
  component: function component() {
    return import('@/pages/shopMall/authentication/authentication');
  }
}, {
  // 店铺列表
  path: '/shopList',
  name: 'shopList',
  meta: {
    noAuth: true,
    title: '店铺列表'
  },
  component: function component() {
    return import('@/pages/shopMall/shopList/shopList');
  }
}, {
  // 店铺首页
  path: '/shopIndex',
  name: 'shopIndex',
  meta: {
    noAuth: true,
    title: '店铺首页'
  },
  component: function component() {
    return import('@/pages/shopMall/shopList/shopIndex');
  }
}, {
  // 店铺搜索列表
  path: '/shopGoodList',
  name: 'shopGoodList',
  meta: {
    noAuth: true,
    title: '店内商品列表'
  },
  component: function component() {
    return import('@/pages/shopMall/shopList/shopGoodList');
  }
}, {
  // 店铺首页
  path: '/casBridge',
  name: 'casBridge',
  component: function component() {
    return import('@/pages/shopMall/casBridge/casBridge');
  }
}, {
  // 店铺[关于我们]
  path: '/shopAbout',
  name: 'shopAbout',
  component: function component() {
    return import('@/pages/shopMall/shopList/shopAbout');
  }
}, // {// 申请上架
//   path: '/addApplyForList',
//   name: 'addApplyForList',
//   component: () => import('@/pages/shopMall/applyForListing/addApplyForList')
// }
// 待办
{
  path: '/todoList',
  name: 'todoList',
  meta: {
    title: '待办'
  },
  component: function component() {
    return import('@/pages/shopMall/todoList/todoList');
  }
}, {
  // 外部访问
  path: '/outOrderDetail',
  name: 'outOrderDetail',
  component: function component() {
    return import('@/pages/orderModule/ecOrderMenu/outOrderDetail.vue');
  }
}, {
  // 外部访问 h5
  path: '/m_outOrderDetail',
  name: 'm_outOrderDetail',
  component: function component() {
    return import('@/pages/orderModule/ecOrderMenu/outOrderDetailH.vue');
  }
}, // 公司简介
{
  path: '/shopIntroduction',
  name: 'shopIntroduction',
  component: function component() {
    return import('@/pages/shopMall/shopList/shopIntroduction.vue');
  }
}, // 联系我们
{
  path: '/shopContactUs',
  name: 'shopContactUs',
  meta: {
    noAuth: true,
    title: '联系我们'
  },
  component: function component() {
    return import('@/pages/shopMall/shopList/shopContactUs.vue');
  }
}, // 新版商城首页
{
  path: '/newShooping',
  name: 'newShooping',
  meta: {
    noAuth: true,
    title: '商城'
  },
  component: function component() {
    return import('@/pages/shopMall/shopping/newShooping');
  }
}, // 新版商城首页
{
  path: '/newShooping',
  name: 'newShooping',
  meta: {
    noAuth: true,
    title: '商城'
  },
  component: function component() {
    return import('@/pages/shopMall/shopping/newShooping');
  }
}, // 首页iframe
{
  path: '/newShopping',
  name: 'newShopping',
  meta: {
    noAuth: true,
    title: '首页'
  },
  component: function component() {
    return import('@/pages/shopMall/shopping/newShopping.vue');
  }
}, // 店铺iframe
{
  path: '/newShopIndex',
  name: 'newShopIndex',
  meta: {
    noAuth: true,
    title: '店铺'
  },
  component: function component() {
    return import('@/pages/shopMall/shopList/newShopIndex.vue');
  }
}, // 新商品列表（iframe）
{
  path: '/newList',
  name: 'newList',
  meta: {
    noAuth: true,
    title: '商城列表'
  },
  component: function component() {
    return import('@/pages/shopMall/list/newList');
  }
}, // 新店铺商品列表
{
  path: '/newShopGoodList',
  name: 'newShopGoodList',
  meta: {
    noAuth: true,
    title: '商城列表'
  },
  component: function component() {
    return import('@/pages/shopMall/shopList/newShopGoodList.vue');
  }
}, // 新店铺商品列表
{
  path: '/enquiryPlaceAnOrder',
  name: 'enquiryPlaceAnOrder',
  meta: {
    noAuth: true,
    title: '询盘单转单'
  },
  component: function component() {
    return import('@/pages/shopMall/cart/enquiryPlaceAnOrder.vue');
  }
}, // 收银台
{
  path: '/cashierDesk',
  name: 'cashierDesk',
  meta: {
    noAuth: true,
    title: '收银台'
  },
  component: function component() {
    return import('@/pages/shopMall/cart/cashierDesk.vue');
  }
}, // 收银台
{
  path: '/downCashierDesk',
  name: 'downCashierDesk',
  meta: {
    noAuth: true,
    title: '收银台'
  },
  component: function component() {
    return import('@/pages/shopMall/cart/cashierDesk.vue');
  }
}, // 支付宝 微信支付
{
  path: '/qrCodePage',
  name: 'qrCodePage',
  meta: {
    noAuth: true,
    title: '收银台'
  },
  component: function component() {
    return import('@/pages/shopMall/cart/qrCodePage.vue');
  }
}, // 支付宝 微信支付成功
{
  path: '/qrCodePageSuccess',
  name: 'qrCodePageSuccess',
  meta: {
    noAuth: true,
    title: '收银台'
  },
  component: function component() {
    return import('@/pages/shopMall/cart/qrCodePageSuccess.vue');
  }
}, // 授信申请BPM-PC
{
  path: '/creditApplication',
  name: 'creditApplication',
  meta: {
    title: '授信申请',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/creditApplication');
  }
}, // 临时额度申请BPM-PC
{
  path: '/limitApplication',
  name: 'limitApplication',
  meta: {
    title: '临时额度申请',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/limitApplication');
  }
}, // 授信申请BPM-移动
{
  path: '/creditApplicationMobile',
  name: 'creditApplicationMobile',
  meta: {
    title: '授信申请',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/creditApplicationMobile');
  }
}, // 临时额度申请BPM-移动
{
  path: '/limitApplicationMobile',
  name: 'limitApplicationMobile',
  meta: {
    title: '临时额度申请',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/limitApplicationMobile');
  }
}, // 大额订单审批BPM-PC
{
  path: '/largeOrder',
  name: 'largeOrder',
  meta: {
    title: '大额订单',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/largeOrder');
  }
}, // 临时额度申请BPM-移动
{
  path: '/largeOrderMobile',
  name: 'largeOrderMobile',
  meta: {
    title: '大额订单',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/largeOrderMobile');
  }
}, // 专业选型
{
  path: '/selectModel',
  name: 'selectModel',
  meta: {
    noAuth: true,
    title: '专业选型'
  },
  component: function component() {
    return import('@/pages/shopMall/majorSelection/majorSelection.vue');
  }
}, // 临时额度申请BPM-PC
{
  path: '/divideOrder',
  name: 'divideOrder',
  meta: {
    title: '分单申请',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/divideOrder');
  }
}, // 临时额度申请BPM-PC
{
  path: '/divideOrderMobile',
  name: 'divideOrderMobile',
  meta: {
    title: '分单申请',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/divideOrderMobile');
  }
}, // 智齿外接商品页
{
  path: '/zhiChiCommodity',
  name: 'zhiChiCommodity',
  meta: {
    title: '智齿商品',
    hidden: true
  },
  component: function component() {
    return import('@/pages/shopMall/zhiChi/zhiChiCommodity');
  }
}, // 智齿外接订单页
{
  path: '/zhiChiOrder',
  name: 'zhiChiOrder',
  meta: {
    title: '智齿订单',
    hidden: true
  },
  component: function component() {
    return import('@/pages/shopMall/zhiChi/zhiChiOrder');
  }
}, // 法务审批BPM-移动
{
  path: '/legalExaminationAndApprovalMobile',
  name: 'legalExaminationAndApprovalMobile',
  meta: {
    title: '法务审批',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/legalExaminationAndApprovalMobile');
  }
}, // 法务审批BPM
{
  path: '/legalExaminationAndApproval',
  name: 'legalExaminationAndApproval',
  meta: {
    title: '法务审批',
    hidden: true
  },
  component: function component() {
    return import('@/pages/operateModule/budgetMenu/creditList/legalExaminationAndApproval');
  }
}];